import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { TrainSelectionType } from "../../../Orchestrator/Types/Index";


export class TrainSelectAction extends BaseAction<string, TrainSelectionType> {

    override async run(): Promise<string | null> {
        let result: string = "";
        try {
            const { train, priceClass, type } = this.params!;
            //updateRecoilState("selectedBookingTripStatus", type);
            if (type === TrainTypeEnum.inbound) {
                const oldSelectedTrainForInBoundBooking = { ...train }
                if (oldSelectedTrainForInBoundBooking.id !== train.id) {
                    oldSelectedTrainForInBoundBooking.selectedPriceClass = priceClass
                } else {
                    oldSelectedTrainForInBoundBooking.selectedPriceClass = oldSelectedTrainForInBoundBooking.selectedPriceClass === priceClass ? null : priceClass
                }
                updateRecoilState("selectedInboundTrainAtom", oldSelectedTrainForInBoundBooking);
            } else {
                const oldSelectedTrainForOutBoundBooking = { ...train }
                if (oldSelectedTrainForOutBoundBooking.id !== train.id) {
                    oldSelectedTrainForOutBoundBooking.selectedPriceClass = priceClass
                } else {
                    oldSelectedTrainForOutBoundBooking.selectedPriceClass = oldSelectedTrainForOutBoundBooking.selectedPriceClass === priceClass ? null : priceClass
                }
                updateRecoilState("selectedOutboundTrainAtom", oldSelectedTrainForOutBoundBooking);
            }

            //Save the original train class selection
            updateRecoilState("originalTrainClassSelectionAtom", {
                //...(originalTrainClassSelectionValue || {}),
                [type]: priceClass,
            })
            
            //Save the initial train class selection
            updateRecoilState("initialTrainClassSelectionAtom", {
                [type]: priceClass,
            })

            result = "success"
        } catch (error) {
            console.error("Error in TrainSelectAction:", error);
        } finally {
            return result
        }
    }
}

// Create a singleton instance
export const trainSelectAction = new TrainSelectAction(); 